import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon';

type AlertType = 'info' | 'success' | 'warning' | 'error';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [CommonModule, IconComponent],
  template: `
    <div [class]="getAlertClasses()">
      <div class="flex gap-3">
        <app-icon
          [name]="getIcon()"
          [className]="'w-5 h-5 flex-shrink-0 ' + getIconColor()"
        ></app-icon>
        <div class="flex-1">
          <h3 *ngIf="title" [class]="'font-bold mb-1 ' + getTitleColor()">
            {{ title }}
          </h3>
          <div [class]="getTextColor()">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  `
})
export class AlertComponent {
  @Input() type: AlertType = 'info';
  @Input() title?: string;
  @Input() className: string = '';

  getAlertClasses(): string {
    const baseClasses = 'rounded-lg p-4 border-l-4';

    const typeClasses = {
      info: 'bg-blue-50 border-blue-600',
      success: 'bg-emerald-50 border-emerald-600',
      warning: 'bg-amber-50 border-amber-600',
      error: 'bg-red-50 border-red-600'
    };

    return `${baseClasses} ${typeClasses[this.type]} ${this.className}`;
  }

  getIcon(): string {
    const icons = {
      info: 'info',
      success: 'check-circle',
      warning: 'alert-circle',
      error: 'alert-circle'
    };
    return icons[this.type];
  }

  getIconColor(): string {
    const colors = {
      info: 'text-blue-600',
      success: 'text-emerald-600',
      warning: 'text-amber-600',
      error: 'text-red-600'
    };
    return colors[this.type];
  }

  getTitleColor(): string {
    const colors = {
      info: 'text-blue-900',
      success: 'text-emerald-900',
      warning: 'text-amber-900',
      error: 'text-red-900'
    };
    return colors[this.type];
  }

  getTextColor(): string {
    const colors = {
      info: 'text-blue-800',
      success: 'text-emerald-800',
      warning: 'text-amber-800',
      error: 'text-red-800'
    };
    return colors[this.type];
  }
}
